module.exports = __webpack_public_path__ + "img/landscape-7.1a7e9c24.jpg";